import { createRouter, createWebHistory } from 'vue-router'; 
import SelectRole from "./components/SelectRole.vue" 
import MusicProducer from "./components/MusicProducer/MusicProducer.vue"; 
import SoundEngineer from "./components/SoundEngineer/SoundEngineer.vue"
import GraphicDesigner from "./components/GraphicDesigner/GraphicDesigner.vue";


const routes = [
  { path: '/', component: SelectRole },
  { path: '/music-producer', component: MusicProducer },
  { path: '/sound-engineer', component: SoundEngineer },
  { path: '/graphic-designer', component: GraphicDesigner },
]

const router = createRouter({
  history: createWebHistory("/work-with-us/form/"),
  routes,
})

export default router